import DepositHtml from './deposit.html';

export function InvoiceDepositService (
  $q,
  $rootScope,
  $translate,
  $uibModal,
  bigDecimalApi,
  dateParsing,
  workshopAPI
) {
  var Deposit = function (invoice, deposit, paymentMethods) {
    this.invoice = invoice;
    this.deposit = deposit || {
      customer_id  : invoice.customer_id,
      date_received: dateParsing.today(),
      invoice_id   : invoice.id,
      payment_type : paymentMethods ? paymentMethods[0].payment_method: '',
      status       : 'O'
    };
  };

  Deposit.prototype.validate = function () {
    const self = this;

    /**
     * WOR-3158, allow deposits on quotes.
     *
     * For quotes, there is no balance so we use the subtotal
     * instead to check against. Deposits can be added to
     * quotes as long as they don't exceed the total.
     *
     * TODO: would be nice to change the type check to use the invoice api, but the service needs to be upgraded first.
     */
    const balance         = bigDecimalApi.get(self.invoice.balance_due);
    const currentDeposits = bigDecimalApi.get(self.invoice.deposits_total);
    const deposit         = bigDecimalApi.get(self.deposit.amount);
    const total           = bigDecimalApi.get(self.invoice.total);

    const isValid = self.invoice.invoice_type === 'Q'
      ? total.subtract(currentDeposits).isGreaterThanOrEqualTo(deposit)
      : deposit.isLessThanOrEqualTo(balance);

    return isValid
      ? $q.when(true)
      : $q.reject($translate.instant('JS_SPACE.MESSAGES.DEPOSITS_CANNOT_BE_GREATER_THAN_BALANCE'));
  };

  Deposit.prototype.add = function (index) {
    const self = this;

    return $uibModal.open({
      controller  : 'DepositCtrl',
      controllerAs: '$ctrl',
      templateUrl : DepositHtml,
      windowClass : 'lg-modal',
      resolve     : {
        deposit: () => index >= 0
          ? angular.copy(self.invoice.customer_deposits_attributes[index])
          : null,
        invoice       : () => self.invoice,
        paymentMethods: () => workshopAPI.get('/invoice_payment_methods')
      }
    }).result
    .then(deposit => {
      if (index >= 0) {
        self.invoice.customer_deposits_attributes[index] = deposit;
      }
      else {
        self.invoice.customer_deposits_attributes.push(deposit);
      }

      $rootScope.$broadcast('calculateTotals');

      return $q.when(deposit);
    });
  };

  Deposit.prototype.remove = function(index) {
    const self           = this;
    const deletedDeposit = self.invoice.customer_deposits_attributes.splice(index, 1)[0];

    if (deletedDeposit.id) {
      deletedDeposit._destroy = '1';

      self.invoice.depositsToDelete.push(deletedDeposit);
    }

    $rootScope.$broadcast('calculateTotals');
  };

  return Deposit;
}